<template>
  <div id="app" class="app-container" :class="{ 'with-tab-bar': showTabBar }">
    <!-- 动态组件渲染当前页面 -->
    <component :is="currentComponent" v-if="currentComponent" />
    
    <!-- 底部导航栏 -->
    <div class="tab-bar" v-if="showTabBar">
      <div 
        v-for="tab in tabList" 
        :key="tab.path"
        @click="navigateToTab(tab.path)"
        :class="['tab-item', { active: currentPath === tab.path }]"
      >
        <img :src="currentPath === tab.path ? tab.selectedIconPath : tab.iconPath" :alt="tab.text" />
        <span>{{ tab.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'

// 导入页面组件
import IndexPage from './pages/index/index.vue'
import AboutPage from './pages/aboutMe/index.vue'
import MobileIndex from './pages/mobile/index.vue'
import MobileLogin from './pages/mobile/login.vue'
import MobileUserCenter from './pages/mobile/user-center.vue'
import MobileVideoCreate from './pages/mobile/video-create.vue'
import MobilePackageCenter from './pages/mobile/package-center.vue'

export default {
  name: 'App',
  components: {
    IndexPage,
    AboutPage,
    MobileIndex,
    MobileLogin,
    MobileUserCenter,
    MobileVideoCreate,
    MobilePackageCenter
  },
  setup() {
    // 页面组件映射
    const pageComponents = {
      '/pages/index/index': 'IndexPage',
      '/pages/aboutMe/index': 'AboutPage',
      '/pages/mobile/index': 'MobileIndex',
      '/pages/mobile/login': 'MobileLogin',
      '/pages/mobile/user-center': 'MobileUserCenter',
      '/pages/mobile/video-create': 'MobileVideoCreate',
      '/pages/mobile/package-center': 'MobilePackageCenter'
    }
    
    // 初始化当前路径，处理查询参数
    const initPath = () => {
      const hash = window.location.hash.replace('#', '') || '/pages/index/index'
      const pathOnly = hash.split('?')[0]
      console.log('Initial hash:', hash);
      console.log('Initial path only:', pathOnly);
      return pageComponents[pathOnly] ? pathOnly : '/pages/index/index'
    }
    
    const currentPath = ref(initPath())
    
    // Tab栏配置
    const tabList = [
      {
        path: '/pages/index/index',
        iconPath: '/static/index.png',
        selectedIconPath: '/static/index1.png',
        text: '首页'
      },
      {
        path: '/pages/mobile/index',
        iconPath: '/static/index.png',
        selectedIconPath: '/static/index1.png',
        text: '神小智AI'
      },
      {
        path: '/pages/aboutMe/index',
        iconPath: '/static/me.png',
        selectedIconPath: '/static/me1.png',
        text: '关于我们'
      }
    ]
    
    // 需要显示Tab栏的页面
    const tabPages = tabList.map(tab => tab.path)
    
    const currentComponent = computed(() => {
      console.log('Computing currentComponent for path:', currentPath.value);
      const component = pageComponents[currentPath.value] || 'IndexPage';
      console.log('Selected component:', component);
      return component;
    })
    
    const showTabBar = computed(() => {
      return currentPath.value !== '/pages/index/index' && tabPages.includes(currentPath.value)
    })
    
    // 导航到Tab页面
    const navigateToTab = (path) => {
      currentPath.value = path
      window.location.hash = path
    }
    
    // 路由导航函数
    const navigateTo = (path) => {
      console.log('App.vue navigateTo called with:', path);
      console.log('Current currentPath:', currentPath.value);
      currentPath.value = path
      window.location.hash = path
      console.log('Updated currentPath to:', currentPath.value);
      console.log('Updated window.location.hash to:', window.location.hash);
    }
    
    // 监听hash变化
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '') || '/pages/index/index'
      console.log('Hash change detected:', hash);
      
      // 分离路径和查询参数
      const pathOnly = hash.split('?')[0]
      console.log('Path only:', pathOnly);
      console.log('Available components:', Object.keys(pageComponents));
      
      if (pageComponents[pathOnly]) {
        console.log('Found matching component for:', pathOnly);
        currentPath.value = pathOnly
      } else {
        console.log('No matching component found, staying on current path:', currentPath.value);
      }
    }
    
    // 全局导航方法
    window.navigateTo = navigateTo
    
    // 覆盖uni.navigateTo方法
    if (window.uni) {
      window.uni.navigateTo = (options) => {
        if (options.url) {
          navigateTo(options.url.replace(/^\//, '/'))
        }
      }
      
      window.uni.redirectTo = (options) => {
        if (options.url) {
          navigateTo(options.url.replace(/^\//, '/'))
        }
      }
    }
    
    onMounted(() => {
      // 初始化路由
      handleHashChange()
      
      // 监听hash变化
      window.addEventListener('hashchange', handleHashChange)
      
      // 移除加载动画
      setTimeout(() => {
        const loading = document.querySelector('.loading')
        if (loading) {
          loading.style.opacity = '0'
          setTimeout(() => loading.remove(), 300)
        }
      }, 1000)
    })
    
    return {
      currentPath,
      currentComponent,
      showTabBar,
      tabList,
      navigateToTab
    }
  }
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
}

/* Tab栏样式 */
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: #ffffff;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1;
}

.tab-item img {
  width: 24px;
  height: 24px;
  margin-bottom: 2px;
}

.tab-item span {
  font-size: 12px;
  color: #666;
  transition: color 0.3s ease;
}

.tab-item.active span {
  color: #2490ff;
}

/* 公共样式 */
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .app-container.with-tab-bar {
    padding-bottom: 60px; /* 为底部Tab栏留出空间 */
  }
}

/* 页面过渡动画 */
.page-enter-active, .page-leave-active {
  transition: opacity 0.3s ease;
}

.page-enter-from, .page-leave-to {
  opacity: 0;
}

/* 暗黑模式支持 */
@media (prefers-color-scheme: dark) {
  .app-container {
    background-color: #141414;
    color: #ffffff;
  }
  
  .tab-bar {
    background: #1a1a1a;
    border-top-color: #333;
  }
  
  .tab-item span {
    color: #999;
  }
  
  .tab-item.active span {
    color: #409eff;
  }
}
</style>
